import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { datadogRum } from '@datadog/browser-rum-slim';

import ErrorComp from '../Error';

import Logger from '../../services/logger';
import { ERROR_BODY_DEFAULT } from '../../constants';

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    datadogRum.addError(error);

    // Display fallback UI
    this.setState({ hasError: true });
    Logger.error(error, info);
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;

    if (hasError) {
      return <ErrorComp errorDescription={ERROR_BODY_DEFAULT} />;
    }
    return children;
  }
}
ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};
